var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._v(" © 2024 PT Mitra Pengadaan ")])
}
var staticRenderFns = []

export { render, staticRenderFns }